import { useSelector } from '../../_shared/utils/hooks/useSelector';
import { type AppState } from '../app.store';

export const boundaryGroupStatsSelector = (state: AppState) => state.stats.boundaryGroupStats;
export const useBoundaryGroupStatsSelector = () => useSelector(boundaryGroupStatsSelector);

const highlightStatsBoundaryGroupSelector = (state: AppState) => state.stats.highlightStatsBoundaryGroup;
export const useHighlightStatsBoundaryGroupSelector = () => useSelector(highlightStatsBoundaryGroupSelector);
